import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {
  FirstMessageApprovalResponse,
  GetMessageDetails,
  getFirstMessageApprovalData,
} from './FirstMessageApprovalSlice'

import {useLocation, useNavigate} from 'react-router-dom'
import FirstApprovalMessageConfirmationPopup from '../../../Components/FirstApprovalMessageConfirmationPopup'
import {fetchAsyncUserDetails} from '../../UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'

const FirstMessageApprovalPage = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const param: any = useLocation()
  const [message, setMessage] = useState('')
  const [approval, setAppoval] = useState(false)

  const [confirmPopup, setConfirmPopup] = useState(false)
  const messageData = useSelector(GetMessageDetails)

  useEffect(() => {
    dispatch(fetchAsyncUserDetails())
    localStorage.removeItem('approval')
    dispatch(getFirstMessageApprovalData(param?.pathname?.split('/')?.at(-2)))
  }, [])

  useEffect(() => {
    if (approval) {
      // if (message?.split(' ')?.includes('testing?')) {
      //   dispatch(
      //     FirstMessageApprovalResponse({
      //       id: param?.pathname?.split('/')?.at(-2),
      //       data: {
      //         status: 'testing',
      //         camp_type: messageData?.camp_type,
      //         notificationId: param?.pathname?.split('/')?.at(-1),
      //       },
      //     })
      //   )
      //   navigate('/dashboard')
      // }

      if (message?.split(' ')?.includes('reject?')) {
        dispatch(
          FirstMessageApprovalResponse({
            id: param?.pathname?.split('/')?.at(-2),
            data: {
              status: 'reject',
              camp_type: messageData?.camp_type,
              notificationId: param?.pathname?.split('/')?.at(-1),
            },
          })
        )
        navigate('/dashboard')
      } else {
        dispatch(
          FirstMessageApprovalResponse({
            id: param?.pathname?.split('/')?.at(-2),
            data: {
              status: 'approved',
              camp_type: messageData?.camp_type,
              notificationId: param?.pathname?.split('/')?.at(-1),
            },
          })
        )
        navigate('/dashboard')
      }
    }
  }, [approval])

  return (
    <>
      <FirstApprovalMessageConfirmationPopup
        show={confirmPopup}
        handleClose={() => setConfirmPopup(false)}
        message={message}
        setAllow={setAppoval}
      />
      {messageData ? (
        <>
          {' '}
          <div className='card pt-4 pb-6 px-9 py-md-8 px-md-14 msg_approval'>
            <div className='card-header border-0 px-0'>
              <h3 className='card-title align-items-start flex-column me-5 mb-0'>
                <span className='card-label fw-bolder fs-2 mb-1'>User Details</span>
              </h3>
            </div>
            <span className='user_name'>
              <b>Status:</b>{' '}
              {messageData?.user?.smsStatus === 'approved' ? 'Verified' : 'UnVerified'}
            </span>
            <span className='user_name'>
              <b>Name:</b> {messageData?.user?.name}
            </span>
            <span className='user_id'>
              <b>Email:</b> <span>{messageData?.user?.email}</span>
            </span>
            <span className='user_id'>
              <b>Mobile:</b> <span>{messageData?.user?.mobile}</span>
            </span>
            <h3 className='card-title align-items-start flex-column me-5 mb-0'>
              <span className='card-label fw-bolder fs-2 mb-1'>
                Recipients: {messageData?.recipientsCount || messageData?.recipients}
              </span>
            </h3>
            <div className='card-header border-0 px-0'>
              <h3 className='card-title align-items-start flex-column me-5 mb-0'>
                <span className='card-label fw-bolder fs-2 mb-1'>
                  Message {`(${messageData?.camp_type?.toUpperCase()})`}
                </span>
              </h3>
            </div>

            <div className='data_block'>
              <p className='msg_data'>{messageData?.message}</p>
              {messageData?.media?.[0]?.url && <img src={messageData?.media?.[0]?.url} alt='img' />}
            </div>
            {['pending', 'testing'].includes(messageData?.campaign_status) ? (
              <div className='msg_btns'>
                <button
                  value={'testing'}
                  onClick={() => {
                    setMessage('Are you sure, you want to send message?')
                    setConfirmPopup(true)
                  }}
                  className='btn btn-primary m-5'
                >
                  Just Send
                </button>
        
                <button
                  value={'reject'}
                  onClick={() => {
                    setMessage('Are you sure, you want to reject?')
                    setConfirmPopup(true)
                  }}
                  className='btn btn-reject m-5'
                >
                  Reject & refund
                </button>
              </div>
            ) : (
              <div className='alert alert-info mt-4'>
                This message has been {messageData?.campaign_status}!
              </div>
            )}
          </div>{' '}
        </>
      ) : (
           <>
            <h1>Message Invalid</h1>
          </>
      )}
    </>
  )
}

export default FirstMessageApprovalPage
